type Output<O, X> = {
  [K in keyof O]: O[K] extends X ? never : O[K]
}

export function omitFalse<O extends object>(object: O): Output<O, undefined | null | false> {
  const copy: any = {}
  for (const [key, value] of Object.entries(object)) {
    if (value == null || value === false) continue
    copy[key] = value
  }
  return copy
}

export function omitBy<In, Out>(object: In, skip: (o: unknown) => boolean): Out {
  const copy: any = {}
  for (const [key, value] of Object.entries(object as {})) {
    if (!skip(value)) copy[key] = value
  }
  return copy
}

export function clone<O extends object>(object: O): O {
  if (typeof structuredClone !== 'undefined') return structuredClone(object)
  try {
    return JSON.parse(JSON.stringify(object))
  } catch {
    return { ...object }
  }
}

export function omitUndefined<T extends object>(object: T): Output<T, undefined> {
  return omitBy(object, v => v === undefined)
}

export function omitNil<T extends object>(object: T): Output<T, undefined | null> {
  return omitBy(object, v => v == null)
}
